import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from "ngx-toastr";
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ModalStudentProfileComponent } from '@component/modal-student-profile/modal-student-profile.component';

import { ProfileService } from '@service/profile.service';
import { AuthService } from '@service/auth.service';
import { Message } from "@model/Message";
import { Profile } from '@model/Profile';

@Component({
  selector: 'app-public-profile',
  templateUrl: './public-profile.component.html',
  styleUrls: ['./public-profile.component.scss']
})
export class PublicProfileComponent implements OnInit {

  @ViewChild('nameInput', { static: false })
  nameInput: any;
  @ViewChild('btnChangeName', { static: false })
  btnChangeName: any;
  @ViewChild('btnSubmitName', { static: false })
  btnSubmitName: any;

  public imgPath;
  public imgURL: any;
  public profile: Array<any> = [];
  public message: any;
  public userFormGroup: FormGroup;
  public userFormNameGroup: FormGroup;

  imageChangedEvent: any = '';
  croppedImage: any = '';

  public nameUpdated: boolean = false;

  constructor(
    private profileService: ProfileService,
    private authService: AuthService,
    private toast: ToastrService,
    private modalService: NgbModal,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.profileService.checkChangedName(this.authService.user.student_institution.user_id)
      .subscribe((res) => {
        this.nameUpdated = res.nameUpdated <= 3 ? true : false;
      });

    this.userFormGroup = this.fb.group({
      currentPassword: [{value: '', disabled: true}, Validators.required],
      password: [{value: '', disabled: true}, Validators.required],
      password_confirmation: [{value: '', disabled: true}, Validators.required]
    });

    this.userFormNameGroup = this.fb.group({
      name: ['', Validators.required]
    });

    const user = this.authService.user;
    this.profile.push({
      name: user.name,
      email: user.email,
      url_image: user.url_image
    });
    this.imgURL = user.url_image || '';
  }

  uploadImage() {
    if (!this.croppedImage) {
      this.toast.error('Selecione uma imagem clicando no botão foto');
      return;
    }

    this.profileService.uploadImage(this.croppedImage)
    .subscribe(events => {
      if(events.type == HttpEventType.UploadProgress) {
        console.log('Upload progress: ', Math.round(events.loaded / events.total * 100) + '%');
      } else if(events.type === HttpEventType.Response) {
        this.imgURL = this.croppedImage;
        this.croppedImage = this.imageChangedEvent = '';
        this.authService.updateNavbarImg(this.imgURL);
        this.toast.success(Message.SUCCESS);
      }
    }, this.errorHandler);
  }

  fileChangeEvent(event: any) {
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }
  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  submitPassword() {
    if (this.userFormGroup.invalid) {
      if (this.userFormGroup.get('currentPassword').hasError('required')) {
        this.toast.error('Preencha o campo Senha Atual');
      }

      if (this.userFormGroup.get('password').hasError('required')) {
        this.toast.error('Preencha o campo Nova Senha');
      }

      if (this.userFormGroup.get('password_confirmation').hasError('required')) {
        this.toast.error('Preencha o campo Confirmar Senha');
      }

      return;
    }

    this.profileService.updatePassword(this.userFormGroup.value)
    .subscribe(() => {
      this.userFormGroup.get('currentPassword').disable();
      this.userFormGroup.get('password').disable();
      this.userFormGroup.get('password_confirmation').disable();
      this.userFormGroup.patchValue({
        currentPassword: '',
        password: '',
        password_confirmation: ''
      });
      this.toast.success(Message.SUCCESS);
    }, this.errorHandler);
  }

  private errorHandler = (e: HttpErrorResponse) => {
    for (const key in e.error.errors) {
      this.toast.error(e.error.errors[key]);
    }
  }

  habiliteEdition() {
    this.userFormGroup.get('currentPassword').enable();
    this.userFormGroup.get('password').enable();
    this.userFormGroup.get('password_confirmation').enable();
    // let i, ativeInput;
    // ativeInput = document.getElementsByClassName('check-input');

    // for (i = 0; i < ativeInput.length; i++) {
    //   if (ativeInput[i].disabled == false) {
    //     ativeInput[i].disabled = true;
    //   } else {
    //     ativeInput[i].disabled = false;
    //   }
    // }
  }

  public preview(files) {
    if (files.length === 0) {
      return;
    }

    let mimiType = files[0].type;

    if (mimiType.match(/image\/*/) == null) {
      this.message = "Somente imagens são suportadas!";
      return;
    }

    let reader = new FileReader();
    this.imgPath = files[0];

    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
      this.onUpdate();
    }
  }

  onUpdate() {
    const playlaod = new FormData();
    playlaod.append('id', this.profile[0].id);
    playlaod.append('picture', this.imgPath);

    this.profileService.uploadImg(playlaod).subscribe(events => {
      if (events.type === HttpEventType.UploadProgress) {
        console.log('Upload Progress', Math.round(events.loaded / events.total * 100) + '%');
      } else if (events.type === HttpEventType.Response) {
        this.toast.success(Message.SUCCESS);
      }
    });
  }

  downloadFile(profile: Profile) {
    this.profileService.downloadFile(profile.id).subscribe((res: any) => {
      const blob = new Blob([res], { type: res.type });
      let reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = (_ev ) => {
        this.imgURL = reader.result;
      }
    });
  }

  openProfileModal() {
    const modalRef = this.modalService.open(ModalStudentProfileComponent);
    modalRef.componentInstance.institutionData = this.authService.user.student_institution;
    modalRef.result.then((res) => {}).catch(() => {});
  }

  showInputName($btn: HTMLElement, $nameInput: HTMLElement) {
    // handle input
    $nameInput.style.display = 'block';
    const previousElementSibling = $nameInput.previousElementSibling;
    previousElementSibling.setAttribute('style', 'display: none;');
    this.userFormNameGroup.patchValue({
      name: previousElementSibling.innerHTML
    });

    // handle button
    $btn.style.display = 'none';
    const nextButtonSibling = $btn.nextElementSibling;
    nextButtonSibling.setAttribute('style', 'display: block;');
  }

  submitName() {
    if (this.userFormNameGroup.invalid) {
      if (this.userFormNameGroup.get('name').hasError('required')) {
        this.toast.error('Preencha o campo Nome');
      }

      return;
    }

    const user = this.authService.user;

    this.profileService.update(this.userFormNameGroup.value, user.student_institution.user_id)
    .subscribe((res) => {
      this.authService.user = {...user, name: this.userFormNameGroup.value.name};
      this.btnChangeName.nativeElement.style.display = 'block';
      this.btnSubmitName.nativeElement.style.display = 'none';
      this.nameInput.nativeElement.style.display = 'none';
      const previousLabel = this.nameInput.nativeElement.previousElementSibling;
      previousLabel.innerHTML = this.userFormNameGroup.value.name;
      previousLabel.setAttribute('style', 'display: block;');
      AuthService.profileUpdated.emit(this.authService.user);
      this.toast.success(Message.SUCCESS);
      this.nameUpdated = res.nameUpdated <= 3 ? true : false;
    }, this.errorHandler);
  }
}
